import { useTranslation } from 'react-i18next';

import { infoBlockWrapper } from '@/components/UserProfile/styles.ts';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import QuoteShape from '@/components/common/svg/shapes/QuoteShape.tsx';

type AboutMeBlockProps = {
  about_me?: string;
};

export const AboutMeBlock = ({ about_me }: AboutMeBlockProps) => {
  const { t } = useTranslation();

  const hasAboutMeBlock = about_me && about_me.trim().length > 0;

  if (!hasAboutMeBlock) return null;

  return (
    <InputContent
      title={t('bio_section')}
      style={{
        color: 'white',
        marginTop: 10,
        marginBottom: 10,
        position: 'relative'
      }}
    >
      <QuoteShape
        width={12}
        height={12}
        style={{
          position: 'absolute',
          top: 30,
          right: 8,
          opacity: 0.8
        }}
      />

      <div
        style={{
          ...infoBlockWrapper,
          paddingRight: 25,
          lineHeight: '1.5'
        }}
      >
        {about_me ?? ''}
      </div>
    </InputContent>
  );
};
